var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLink24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_link24x24",
    transform: "translate(-.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(.147 5.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M9.807,165.706a3.627,3.627,0,0,0-.622-.5,3.731,3.731,0,0,0-4.65.5L1.145,169.1a3.731,3.731,0,0,0,5.266,5.278l2.766-3.02a.266.266,0,0,0-.189-.456H8.882a4.484,4.484,0,0,1-1.705-.33.266.266,0,0,0-.29.059l-1.977,2.233A1.6,1.6,0,1,1,2.647,170.6l3.4-3.4a1.6,1.6,0,0,1,2.26,0,1.093,1.093,0,0,0,1.5,0,1.055,1.055,0,0,0,0-1.5Z",
    transform: "translate(-.147 -164.614)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(6.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M198.481,1.093a3.731,3.731,0,0,0-5.276,0l-1.026.97a.266.266,0,0,0,.195.456h.1a4.477,4.477,0,0,1,1.7.333.266.266,0,0,0,.29-.059l.237-.178a1.6,1.6,0,1,1,2.259,2.259l-2.5,2.5-.021.024-.874.869a1.6,1.6,0,0,1-2.26,0,1.093,1.093,0,0,0-1.5,0,1.066,1.066,0,0,0,0,1.5,3.7,3.7,0,0,0,1.066.746c.056.027.112.048.168.072s.115.043.171.064.115.04.171.056l.157.043c.107.027.213.048.322.067a3.709,3.709,0,0,0,.4.037h.2l.16-.019c.059,0,.12-.016.189-.016h.089l.184-.027.089-.016.155-.032h.029a3.731,3.731,0,0,0,1.729-.977l3.392-3.392a3.731,3.731,0,0,0,0-5.281Z",
    transform: "translate(-189.503)",
    fill: "#999"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLink24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_link24x24.c156c8748494b73c480d7518546e7f88.svg";